import st from "@/styles/Ui.module.scss"
import TextField from "@/ui/TextField.tsx";
import React, {useEffect, useRef, useState} from "react";
import clsx from "clsx";
import { pwd_value } from "@/atoms/common.ts";
import {useAtom} from "jotai";
import {useTranslation} from "react-i18next";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";
import ClosedEyeIcon from "@/svg/ClosedEyeIcon.tsx";
import EyeIcon from "@/svg/EyeIcon.tsx";
import Switcher from "@/ui/Switcher.tsx";
import {useLocation} from "react-router-dom";


interface Props {
    className?: string
    onChange?(): void
    error?:boolean
}

const WritePwdFields:React.FC<Props> = ({className, onChange, error}) => {
    
    const {t} = useTranslation()
    const effect_ran = useRef<boolean>(false)
    const [pwd, setPwd] = useAtom(pwd_value);
    const [hide, set_hide] = useState<boolean>(true)
    const [err_text, set_err_text] = useState<string>("")
    const focused = useRef<boolean>(false)
    const maxLength = 1
    const id_root = `input_pwd_`
    const location = useLocation()
    
    const err_text_handle = (x:string) => {
        set_err_text(x)
    }
    
    const keydown = (e: any) => {
        let newPwd = [...pwd];
        
        let id = Number(e.target.id[e.target.id.length - 1]);
        const current: any = document.getElementById(`${id_root}${id}`);
        
        let prev_id = id - 1;
        const prev_input: any = document.getElementById(`${id_root}${prev_id}`);
        
        let next_id = id + 1;
        const next_input: any = document.getElementById(`${id_root}${next_id}`);
        
        if (/^\d$/.test(e.key)) {
            newPwd[id] = e.key;
            
            if (next_input) {
                next_input.focus();
            }
        }
        
        if (e.key === "Backspace") {
            if (current.value.length) {
                newPwd[id] = "";
            } else {
                newPwd[prev_id] = "";

                if (prev_input) {
                    e.preventDefault();
                    prev_input.focus();
                }
            }
        }
        
        if (e.key === " " || e.key === "ArrowRight") {
            if (next_input) {
                next_input.focus();
            }
        }
        
        if (e.key === "ArrowLeft") {
            if (prev_input) {
                prev_input.focus();
            }
        }
        
        setPwd(newPwd);
    };

    const resetPwd = () => {
        const first_input = document.getElementById(`${id_root}0`)
        
        if(first_input) {
            first_input.focus()
        }
        
        setPwd(['', '', '', ''])
    }
    
    const onPasteHandler = (e:any) => {
        const clipboardData = e.clipboardData;
        const pastedText = clipboardData.getData('text');
        
        let arr:Array<string> = []
        
        if(pastedText.length === 4) {
            pastedText.split("").map((t:string) => {
                if(Number(t) || t === "0") {
                    arr.push(t)
                }
            })
            
            if(arr.length === 4) {
                
                arr.map((str, i) => {
                    let elem = document.getElementById(`${id_root}${i}`)
                    
                    if(elem) {
                        (elem as HTMLInputElement).value = str
                    }
                    
                })
                
                setPwd(arr)
                
            }
        }
    }
    
    
    useEffect(() => {
        const first_input = document.getElementById(`${id_root}0`)
        eventEmitter.on(CommonClass.CustomEvents.set_pwd_err_text, err_text_handle)
        if(first_input) {
            first_input.focus()
        }
        
        if(!effect_ran.current) {
            eventEmitter.on(CommonClass.CustomEvents.reset_pwd_value, resetPwd)
        }
        
        return () => {
            effect_ran.current = true
            eventEmitter.off(CommonClass.CustomEvents.set_pwd_err_text, err_text_handle)
            if(!effect_ran.current) {
                eventEmitter.off(CommonClass.CustomEvents.reset_pwd_value, resetPwd)
            }
        }
        
    }, []);
    
    useEffect(() => {
        set_err_text("")
    }, [location.pathname]);
    
    return (
        <div className={clsx(st.pwd_fields, className && className)}>
            <div className={st.fields}>
                {pwd.map((digit:any, index:number) => {
                    
                    let val =  hide ? digit.length ? "●" : "" : digit
                    
                    return (
                        <TextField
                            error={error && error}
                            key={index}
                            name={`pin${index}`}
                            type={"tel"}
                            value={val}
                            onFocus={(_e:any) => {
                                focused.current = true
                            }}
                            onBlur={(_e:any) => {
                                focused.current = false
                            }}
                            handleKeyDown={(e:any) => keydown(e)}
                            inputMode={"numeric"}
                            onChange={(_e:any) => {
                                
                                if(typeof onChange === "function") {
                                    onChange()
                                }
                            }}
                            maxLength={maxLength}
                            className={clsx(st.inputs, hide && st.pwd_hidden)}
                            id={`${id_root}${index}`}
                            onPaste={onPasteHandler}
                        />
                    )
                })}
            </div>
            
            {err_text.length ? (
                <span className={st.err_text}>{err_text}</span>
            ) : null}
            
            <div className={st.see_pwd}>
                
                <div
                    onClick={() => {
                        set_hide((x:boolean) => !x)
                    }}
                    className={st.left}
                >
                    {hide ?  <ClosedEyeIcon /> : <EyeIcon /> }
                    {t("show_pin")}
                </div>
                
                
                <Switcher
                    checked={!hide}
                    onChange={() => {
                        set_hide((x:boolean) => !x)
                    }}
                />
            </div>
            
   
        </div>
    );
}

export default WritePwdFields